// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"857c9e6e","520":"80a55608","582":"fabf19ee"}[chunkId] + ".chunk.css";
};